module.exports = __webpack_public_path__ + "static/media/1.849a1663.jpg";